import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { Provider } from "react-redux";
import { store } from "./store";
import { Routes } from "./_config/routes";
import "./_styles/all.css";
import { theme } from "./_styles/theme";

const ThemeApp = () => {  
  const customTheme = extendTheme({
    ...theme,
    colors: {
      main: theme.colors.blue
    }
  });

  return (
    <ChakraProvider resetCSS theme={customTheme}>
      <Routes />
    </ChakraProvider>
  );
};

export const App = () => {
  return (
    <Provider store={store}>
        <ThemeApp />      
    </Provider>
  );
};
